"use strict";

exports.__esModule = true;
exports.default = isObject;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// Is a given variable an object?
function isObject(obj) {
  var type = _typeof(obj);
  return type === 'function' || type === 'object' && !!obj;
}